<template>
  <div :style="{height:height+'px',width:width+'px'}">
    <div :id="playerId"></div>
    <!-- 播放器按钮控制器 -->
    <div class="playCtrl">
      <div class="left">
        <el-link :underline="false" v-if="action!='playing'" @click="h5Play"><i class="iconfont icon-h5play" />
        </el-link>
        <el-link :underline="false" v-if="action=='playing'" @click="h5Stop">
          <i class="iconfont icon-h5pause" />
          <!-- {{isPlayBack?'暂停':'停止'}} -->
        </el-link>
      </div>
      <div class="right">
        <el-link class="volume" :underline="false">
          <i class="iconfont icon-h5volume" />
          <el-slider :disabled="action!='playing'" v-model="curVolume" @change="h5SetVolume" vertical height="100px">
          </el-slider>
        </el-link>
        <el-link :underline="false" @click="h5FullScreen"><i class="iconfont icon-h5fullscreen" /></el-link>
      </div>
    </div>
    <div>
    </div>
  </div>
</template>
<script>
import { newGuid } from '@/configs/functions'
import { getPreviewURLs } from '@/api/cam/index'

var playAction = {
  none: 'none',
  playing: 'playing',
  stop: 'stop',
  pause: 'pause',
}
moment.locale('./static/js/zh-cn.js')
// const IS_MOVE_DEVICE = document.body.clientWidth < 992 // 是否移动设备
// const MSE_IS_SUPPORT = !!window.MediaSource // 是否支持mse
export default {
  name: "h5player",
  props: {
    width: {
      type: Number,
      default: 600
    },
    height: {
      type: Number,
      default: 400
    },
    //通过编码读取文件流，在播放
    code: {
      type: String,
      default: ''
    },
    isPlayBack: {
      type: Boolean,
      default: false
    },
    autoPlay: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      curVolume: 50,
      playerId: 'divH5Player',
      player: null,
      action: 'stop',
      mode: 1,//0普通模式 1高级模式
      // splitNum: IS_MOVE_DEVICE ? 1 : 2,
      // mseSupport: MSE_IS_SUPPORT,
      // tabActive: MSE_IS_SUPPORT ? 'mse' : 'decoder',
      // mode: tabActive == 'mse' ? 0 : 1,      
      urls: {
        realplay: '',
        talk: 'wss://10.41.163.126:6014/proxy/10.41.163.126:559/EUrl/6gFx47S',
        playback: ''
      },
      playback: {
        startTime: '',// '2021-07-26T00:00:00',
        endTime: '',//2021-07-26T23:59:59',
        valueFormat: moment.HTML5_FMT.DATETIME_LOCAL_SECONDS,
        seekStart: '2021-07-26T12:00:00',
        rate: ''
      }
    }
  },
  computed: {
    /** 0:mse 普通模式 1:decoder 高级模式
    mode: function () {
      return MSE_IS_SUPPORT ? 0 : 1
    }
    */
  },
  created() {
    this.playerId = 'divH5Player' + newGuid()
  },
  mounted() {
    this.init()
    this.createPlayer()
    this.action = ''
    // this.realplay()
  },
  beforeDestroy() {
    console.log('h5 beforeDestroy')
    this.h5DestroyPlayer()
  },
  methods: {
    h5SetOption(opt) {
      this.code = opt.code
      if (opt.playBack) {
        this.isPlayBack = true
        //默认播放时间段为一天
        var startTimeStamp = new Date().getTime() - 24 * 60 * 60 * 1000; //回放开始时间戳，必填 
        var endTimeStamp = new Date().getTime(); //回放结束时间戳，必填
        var pb = this.playback
        pb.startTime = startTimeStamp
        pg.endTime == endTimeStamp
      }
      if (this.autoPlay) {
        this.h5Play()
      }
    },
    h5Play() {
      if (this.code == '') {
        this.$message.warning('没有可以播放的视频')
        return false
      }
      if (this.isPlayBack) {
        var pb = this.playback
        if (pb.startTime = '' || pg.endTime == '') {
          this.$message.warning('请选择回放时间段')
          return false
        }
      }
      getPreviewURLs(this.code).then((response) => {
        const data = response.data
        if (data && !data.IsError) {
          // this.$message('流文件获取成功，正在加载播放器!')
          if (this.isPlayBack) {
            this.urls.playback = data.MsgObj
            this.playbackStart()
          }
          else {
            this.urls.realplay = data.MsgObj
            this.realplay()
          }
        }
        else {
          this.$message({
            dangerouslyUseHTMLString: true, message: `${data.Message}`, type: 'warning'
          })
        }
      })
    },
    h5Stop() {
      if (this.isPlayBack) {
        this.playbackPause()
      }
      else {
        this.stopPlay()
      }
    },
    h5SetVolume() {
      this.openSound()
      this.setVolume(this.curVolume)
    },
    h5FullScreen() {
      this.wholeFullScreen()
    },
    h5DestroyPlayer() {
      console.log('h5DestroyPlayer')
      window.removeEventListener('resize', () => { this.player.JS_Resize() })
      if (this.player != null) {
        this.stopAllPlay()
        this.player = null
      }
    },
    init() {
      // 设置播放容器的宽高并监听窗口大小变化
      window.addEventListener('resize', () => {
        this.player.JS_Resize()
      })
    },
    createPlayer() {
      this.player = new window.JSPlugin({
        szId: this.playerId,
        szBasePath: "/js/Hik/h5/",// 必填,引用H5player.min.js的js相对路径
        iMaxSplit: 4,
        iCurrentSplit: 1,//IS_MOVE_DEVICE ? 1 : 2,
        openDebug: true,
        oStyle: {
          borderSelect: '#000',// IS_MOVE_DEVICE ? '#000' : '#FFCC00',
        },
        // 当容器div#play_window有固定宽高时，可不传iWidth和iHeight，窗口大小将自适应容器宽高
        iWidth: this.width,
        iHeight: this.height,

        // 分屏播放，默认最大分屏4*4
        // iMaxSplit: 4,
        // iCurrentSplit: 1,

        // 样式
        // oStyle: {
        //   border: "#343434",
        //   borderSelect: "#FFCC00",
        //   background: "#000"
        // }
      })
      // 事件回调绑定
      this.player.JS_SetWindowControlCallback({
        windowEventSelect: function (iWndIndex) {
          //插件选中窗口回调
          console.log('插件选中窗口回调 windowSelect callback: ', iWndIndex);
        },
        pluginErrorHandler: function (iWndIndex, iErrorCode, oError) {
          //插件错误回调
          console.log('插件错误回调 pluginError callback: ', iWndIndex, iErrorCode, oError);
        },
        windowEventOver: function (iWndIndex) {
          //鼠标移过回调
          // console.log('鼠标移过回调:', iWndIndex);
        },
        windowEventOut: function (iWndIndex) {
          //鼠标移出回调
          // console.log('鼠标移出回调:', iWndIndex);
        },
        windowEventUp: function (iWndIndex) {
          //鼠标mouseup事件回调
          // console.log('鼠标mouseup事件回调:', iWndIndex);
        },
        windowFullCcreenChange: function (bFull) {
          //全屏切换回调
          console.log('全屏切换回调 fullScreen callback: ', bFull);
        },
        firstFrameDisplay: function (iWndIndex, iWidth, iHeight) {
          //首帧显示回调
          console.log('首帧显示回调 firstFrame loaded callback: ', iWndIndex, iWidth, iHeight);
        },
        performanceLack: function () {
          //性能不足回调
          console.log('性能不足回调 performanceLack callback: ');
        }
      });
    },
    /** 分屏 */
    arrangeWindow() {
      let splitNum = 1// this.splitNum
      this.player.JS_ArrangeWindow(splitNum).then(
        () => { console.log(`arrangeWindow to ${splitNum}x${splitNum} success`) },
        e => { console.error(e) }
      )
    },
    /** 整体全屏 */
    wholeFullScreen() {
      this.player.JS_FullScreenDisplay(true).then(
        () => { console.log(`wholeFullScreen success`) },
        e => { console.error(e) }
      )
    },
    /* 预览&对讲 */
    realplay() {
      let { player, mode, urls } = this,
        index = player.currentWindowIndex,
        playURL = urls.realplay

      player.JS_Play(playURL, { playURL, mode }, index).then(
        () => {
          this.action = playAction.playing
          console.log('realplay success')
        },
        e => { console.error(e) }
      )
    },
    stopPlay() {
      this.player.JS_Stop().then(
        () => {
          this.playback.rate = 0;
          this.action = playAction.stop;
          console.log('stop realplay success')
        },
        e => { console.error(e) }
      )
    },
    talkStart() {
      let url = this.urls.talk
      this.player.JS_StartTalk(url).then(
        () => { console.log('talkStart success') },
        e => { console.error(e) }
      )
    },
    talkStop() {
      this.player.JS_StopTalk().then(
        () => { console.log('talkStop success') },
        e => { console.error(e) }
      )
    },
    stopAllPlay() {
      this.player.JS_StopRealPlayAll().then(
        () => {
          this.playback.rate = 0;
          this.action = playAction.stop;
          console.log('stopAllPlay success')
        },
        e => { console.error(e) }
      )
    },
    /* 回放 */
    playbackStart() {
      let { player, mode, urls, playback } = this,
        index = player.currentWindowIndex,
        playURL = urls.playback,
        { startTime, endTime } = playback

      startTime += 'Z'
      endTime += 'Z'

      player.JS_Play(playURL, { playURL, mode }, index, startTime, endTime).then(
        () => {
          this.action = playAction.playing
          console.log('playbackStart success')
          this.playback.rate = 1
        },
        e => { console.error(e) }
      )
    },
    playbackPause() {
      this.player.JS_Pause().then(
        () => {
          this.action = playAction.pause
          console.log('playbackPause success')
        },
        e => { console.error(e) }
      )
    },
    playbackResume() {
      this.player.JS_Resume().then(
        () => { console.log('playbackResume success') },
        e => { console.error(e) }
      )
    },
    seekTo() {
      let { seekStart, endTime } = this.playback
      seekStart += 'Z'
      endTime += 'Z'
      this.player.JS_Seek(this.player.currentWindowIndex, seekStart, endTime).then(
        () => { console.log('seekTo success') },
        e => { console.error(e) }
      )
    },
    playbackSlow() {
      this.player.JS_Slow().then(
        rate => {
          this.playback.rate = rate
        },
        e => { console.error(e) }
      )
    },
    playbackFast() {
      this.player.JS_Fast().then(
        rate => {
          this.playback.rate = rate
        },
        e => { console.error(e) }
      )
    },
    frameForward() {
      this.player.JS_FrameForward(this.player.currentWindowIndex).then(
        () => { this.playback.rate = 1; console.log('frameForward success') },
        e => { console.error(e) }
      )
    },
    /* 声音、抓图、录像 */
    openSound() {
      this.player.JS_OpenSound().then(
        () => {
          console.log('openSound success')
          this.muted = false
        },
        e => { console.error(e) }
      )
    },
    closeSound() {
      this.player.JS_CloseSound().then(
        () => {
          console.log('closeSound success')
          this.muted = true
        },
        e => { console.error(e) }
      )
    },
    setVolume(value) {
      let player = this.player,
        index = player.currentWindowIndex
      this.player.JS_SetVolume(index, value).then(
        () => {
          console.log('setVolume success', value)
        },
        e => { console.error(e) }
      )
    },
    capture(imageType) {
      let player = this.player,
        index = player.currentWindowIndex

      player.JS_CapturePicture(index, 'img', imageType).then(
        () => { console.log('capture success', imageType) },
        e => { console.error(e) }
      )
    },
    /* 抓图 */
    recordStart(type) {
      const codeMap = { MP4: 5, PS: 2 }
      let player = this.player,
        index = player.currentWindowIndex,
        fileName = `${moment().format('YYYYMMDDHHmm')}.mp4`
      typeCode = codeMap[type]

      player.JS_StartSaveEx(index, fileName, typeCode).then(
        () => { console.log('record start ...') },
        e => { console.error(e) }
      )
    },
    /* 录像 */
    recordStop() {
      let player = this.player
      index = player.currentWindowIndex

      player.JS_StopSave(index).then(
        () => { console.log('record stoped, saving ...') },
        e => { console.error(e) }
      )
    },
    /* 电子放大、智能信息 */
    enlarge() {
      let player = this.player,
        index = player.currentWindowIndex

      player.JS_EnableZoom(index).then(
        () => { console.log('enlarge start..., select range...') },
        e => { console.error(e) }
      )
    },
    enlargeClose() {
      let player = this.player,
        index = player.currentWindowIndex

      player.JS_DisableZoom(index).then(
        () => { console.log('enlargeClose success') },
        e => { console.error(e) }
      )
    },
    intellectTrigger(openFlag) {
      let player = this.player,
        index = player.currentWindowIndex

      let result = player.JS_RenderALLPrivateData(index, openFlag)
      console.log(`${openFlag ? 'open' : 'close'} intellect ${result === 1 ? 'success' : 'failed'}`)
    },
    getVideoInfo() {
      let player = this.player,
        index = player.currentWindowIndex

      player.JS_GetVideoInfo(index).then(function (videoInfo) {
        console.log("videoInfo:", videoInfo);
      });
    },
    getOSDTime() {
      let player = this.player,
        index = player.currentWindowIndex

      player.JS_GetOSDTime(index).then(function (time) {
        console.log("osdTime:", new Date(time));
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.playCtrl {
  margin: 0px;
  padding: 0;
  background: #fff;
  height: 36px;
  line-height: 36px;
  border: solid 1px #000;
  border-top: 0px;
  .el-link {
    padding: 5px;
    color: #000;
  }
  .left {
    float: left;
  }
  .right {
    float: right;
  }
  .volume {
    position: relative;
    .el-slider {
      display: none;
      position: absolute;
      bottom: 22px;
      left: -8px;
    }
    &:hover .el-slider {
      display: block;
      .el-slider__bar {
        background-color: #000 !important;
      }
    }
  }
}
</style>
